import { getDocumentRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';

export const getMyDocumentsRoot = (state: ApplicationState) => getDocumentRoot(state).myDocuments;
export const getSearchDocumentsRoot = (state: ApplicationState) => getDocumentRoot(state).search;
export const getDocumentAnalyticsRoot = (state: ApplicationState) => getDocumentRoot(state).analytics;
export const getDocumentReportingRoot = (state: ApplicationState) => getDocumentRoot(state).reporting;
export const getDocumentChatbotRoot = (state: ApplicationState) => getDocumentRoot(state).chatbot;
